module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Example', {
    attrs: {
      "component": _vm.ExAlertDialog,
      "code": _vm.ExAlertDialogCode,
      "title": "Alert"
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExConfirmDialog,
      "code": _vm.ExConfirmDialogCode,
      "title": "Confirm"
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExPromptDialog,
      "code": _vm.ExPromptDialogCode,
      "title": "Prompt"
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "title": "From outside Vue instance"
    }
  }, [_c('p', [_vm._v("You can use it on Vuex or VueRouter using this syntax:")]), _vm._v(" "), _c('CodeView', {
    attrs: {
      "lang": "javascript",
      "code": _vm._f("pre")(_vm.outsideVueInstance),
      "expanded": ""
    }
  })], 1), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c5d99ad"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/dialog/Dialog.vue
// module id = 1383
// module chunks = 32